export enum EmptyStatePageDataHooks {
  TITLE = 'empty-state-title',
  SUBTITLE = 'empty-state-subtitle',
  SPINNER = 'empty-state-spinner',
  CONTAINER = 'empty-state-container',
}
